export default __webpack_public_path__ + "static/media/flop.2bca7cb6.svg";